import { render, staticRenderFns } from "./StepCompleted.vue?vue&type=template&id=06e5428d&scoped=true"
import script from "./StepCompleted.vue?vue&type=script&lang=js"
export * from "./StepCompleted.vue?vue&type=script&lang=js"
import style0 from "./StepCompleted.vue?vue&type=style&index=0&id=06e5428d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5428d",
  null
  
)

export default component.exports